// Copyright (c) 2019-present Ladifire, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import React from 'react';
import classNames from 'classnames';

import * as styles from '../../styles/components/button/style.scss';

interface Props {
    followsIcon: boolean;
    spacing: string;
    children?: React.ReactNode;
    isLoading?: boolean;
    testId?: string;
}

export default ({
    children,
    followsIcon,
    spacing,
    isLoading,
    ...rest
}: Props) => (
    <span
        className={classNames(styles.button__content, {
            [styles.follows_icon]: followsIcon,
            [styles.is_loading]: isLoading,
            [styles.no_spacing]: spacing === 'none',
        })}
        {...rest}
    >
        {children}
    </span>
);
